import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@macs-frontend/core';
import { environment } from '@macs-frontend/env';
import { State } from '@macs-frontend/reducers';
import { UploadedFile } from '@macs-frontend/web-macs/shared/models/uploaded-file';
import { Store } from '@ngrx/store';

@Component({
  selector: 'md-attached',
  templateUrl: 'attached.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachedComponent extends BaseComponent {
  // @ts-expect-error
  @Input() files: (File | UploadedFile)[];
  @Input() readOnly = false;
  @Input() label = 'Attached files';
  @Output() upload: EventEmitter<File | Event> = new EventEmitter<File | Event>();
  @Output() remove: EventEmitter<File | UploadedFile> = new EventEmitter<
    File | UploadedFile
  >();
  imagesPath = environment.images_path;

  public typeIcons = {
    docx: 'word',
    doc: 'word',
    txt: 'small',
    zip: 'archive',
    pdf: 'pdf',
    xls: 'excel',
    xlsx: 'excel',
    default: 'image',
  };

  uploadFile(file: File | Event) {
    this.upload.emit(file);
  }

  removeFile(file: File | UploadedFile) {
    this.remove.emit(file as File);
  }

  downloadFile(file: string) {
    this.router.navigate([`${this.imagesPath}/${file}`]);
  }

  getIcon(file: string): string {
    const type = file.split('.').pop();
    // @ts-expect-error
    return this.typeIcons[type] || this.typeIcons['default'];
  }

  getUploadedFile(file: File | UploadedFile): null | UploadedFile {
    return file.hasOwnProperty('file') ? (file as UploadedFile) : null;
  }

  constructor(
    private router: Router,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<State>,
  ) {
    super();
  }
}
